import { render, staticRenderFns } from "./CollegeSectionCreate.vue?vue&type=template&id=74de89cf&scoped=true&"
import script from "./CollegeSectionCreate.vue?vue&type=script&lang=js&"
export * from "./CollegeSectionCreate.vue?vue&type=script&lang=js&"
import style0 from "./CollegeSectionCreate.vue?vue&type=style&index=0&id=74de89cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de89cf",
  null
  
)

export default component.exports